module.exports = __webpack_public_path__ + "img/feature-three.d3740235.svg";